import React from "react";
import styles from "./ColorDot.scss";
import classNames from "classnames";

export const ColorDot = ({ color }) => {
    return (
        <svg
            className={classNames(styles.base, {
                [styles.colorSuccess]: color === "success",
                [styles.colorWarning]: color === "warning",
                [styles.colorError]: color === "error",
                [styles.colorBase]: color === "base"
            })}
            width={16}
            height={16}
            style={{
                verticalAlign: "middle"
            }}
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 29.107 29.107"
        >
            <circle cx="14.554" cy="14.554" r="14.554" />
        </svg>
    );
};
